import { PerspectiveGrid } from './js/PerspectiveGrid.js';
import { VanishingPoint } from './js/VanishingPoint.js';
import { PerspectiveParagraph } from './js/PerspectiveParagraph.js';

function setup() {
  document.body.style.height = "10000px";

  const canvas = document.getElementById('perspectiveGrid');
  const vanishingPointObj = new VanishingPoint(canvas);

const grid = new PerspectiveGrid(canvas, vanishingPointObj, {
  numVertical: 12,
  groundSpacing: 500, // try 120-200 for wide ground!
  perspectiveExponent: 1.6,
  perspectiveSpread: 20,
  lineColor: "#222",
  lineWidth: 1
});

  // Dynamic paragraphs
const paragraphContents = [
  "capitale culturelle 2027\nla chaux-de-fonds",
  "second dynamic paragraph\nthat follows the first",
  "third paragraph with even more spacing"
];
const paragraphs = [];
paragraphContents.forEach((content, idx) => {
  const el = document.createElement("div");
  el.className = "perspective-paragraph";
  el.innerHTML = content;
  document.body.appendChild(el);

  // Spacing of 2000px between each paragraph
  const anchorScroll = 3000 * idx;
  paragraphs.push(new PerspectiveParagraph(el, vanishingPointObj, anchorScroll));
});




  function resize() {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    vanishingPointObj.update();
    updateScene(window.scrollY);
  }

  function updateScene(scrollDepth) {
    grid.draw(scrollDepth);
    paragraphs.forEach(p => p.update(scrollDepth));
  }

  window.addEventListener('resize', resize);
  window.addEventListener('scroll', () => updateScene(window.scrollY));
  resize();
}

window.onload = setup;